// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"708f120e","316":"fddee9f5","604":"1cc06632","789":"31b68edc"}[chunkId] + ".chunk.js";
};